import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const addContentLanguage = api(async function addContentLanguage({ code, name, nativeName, rtl }) {
    return mutate(
        gql`
            mutation AddContentLanguage($code: String!, $name: String!, $nativeName: String, $rtl: Boolean) {
                addContentLanguage(code: $code, name: $name, nativeName: $nativeName, rtl: $rtl) {
                    _id
                    code
                    name
                    nativeName
                    rtl
                }
            }
        `,
        { code, name, nativeName, rtl },
        { returns: "addContentLanguage" }
    )
})
